export function buildReportsPageURL() {
  return '/reports'
}
